<div class="container-fluid d-flex align-items-center justify-content-center min-vh-100">
  <div class="text-center">
    <div class="mb-4">
      <i class="fas fa-shield-alt text-warning" style="font-size: 4rem;"></i>
    </div>
    
    <h1 class="display-4 text-danger mb-3">Rate Limit Excedido</h1>
    
    <div class="alert alert-warning" role="alert">
      <h4 class="alert-heading">Muitas tentativas detectadas!</h4>
      <p>Você excedeu o limite de requisições permitidas. Por favor, aguarde antes de tentar novamente.</p>
      <hr>
      <p class="mb-0">
        <strong>Tempo restante:</strong> 
        <span class="badge bg-danger fs-6">{{ countdown }}s</span>
      </p>
    </div>
    
    <div class="mt-4">
      <button class="btn btn-primary" (click)="goHome()">
        <i class="fas fa-home me-2"></i>
        Voltar ao Início
      </button>
    </div>
    
    <div class="mt-5">
      <small class="text-muted">
        Esta medida de segurança protege o sistema contra ataques de força bruta.
      </small>
    </div>
  </div>
</div>
